import React from 'react';
import { withRouter } from 'react-router';
import VerificationCompleted from './VerificationCompleted';
import VerificationPartial from './VerificationPartial';

import './VerificationSuccessful.css';
import useVerificationSuccessfulContainer from "./VerificationSuccessfullContainer";

const VerificationSuccessFul = (props) => {
  
 const {
   state: {
     userName, email, mobileNumber,
     getOtpResponse, verifyOtpResponse,verificationCompleted
   },
   action: {
     _toggleChoice,
     _getOtpAction,
     _verifyOtpAction,
     completeVerification
   },
 } = useVerificationSuccessfulContainer();

    return (
      <React.Fragment>
        {verificationCompleted
          ? (
            <VerificationCompleted
              userName={userName}
              reviewData={props.reviewData}
              toggleChoice={_toggleChoice}
            />
          )
          : (
            <VerificationPartial
              getOtp={_getOtpAction}
              verifyOtp={_verifyOtpAction}
              userName={userName}
              email={email}
              mobileNumber={mobileNumber}
              getOtpResponse={getOtpResponse}
              verifyOtpResponse={verifyOtpResponse}
              completeVerification={completeVerification}
            />
          )
        }
      </React.Fragment>
    );
  }

  export default withRouter(VerificationSuccessFul);
